import { h } from 'preact';
import MaterialComponent from '../Base/MaterialComponent';
const generatedProps = [];
for (let elevationIndex = 0; elevationIndex < 25; elevationIndex++) {
    generatedProps.push('z' + elevationIndex);
}
export class Elevation extends MaterialComponent {
    constructor() {
        super(...arguments);
        this.componentName = 'elevation';
        this.mdcProps = generatedProps;
    }
    materialDom(props) {
        let className;
        if (props.z) {
            className = 'mdc-elevation--z' + props.z;
        }
        return (h("p", Object.assign({ className: className }, props, { ref: this.setControlRef }), props.children));
    }
}
export default Elevation;
//# sourceMappingURL=index.js.map